import request from "./request";

export const login = (payload) => request.post("/login", payload);
export const getMe = () => request.get("/me");
export const getNovels = () => request.get("/novels");
export const createNovel = (payload) => request.post("/novels", payload);
export const updateNovel = (novelKey, payload) => request.put(`/novels/${novelKey}`, payload);
export const deleteNovel = (novelKey) => request.delete(`/novels/${novelKey}`);
export const getUsers = () => request.get("/users");
export const createUser = (payload) => request.post("/users", payload);
export const deleteUser = (id) => request.delete(`/users/${id}`);
export const downloadDataBackup = () =>
  request.get("/admin/backup/data", {
    timeout: 600000,
  });

export const uploadDataRestore = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/admin/backup/restore", formData, {
    timeout: 600000,
  });
};

export const listBackups = () => request.get("/admin/backups");

export const downloadBackup = (filename) =>
  request.get(`/admin/backups/${encodeURIComponent(filename)}/download`, {
    responseType: "blob",
    timeout: 600000,
  });

export const restoreBackup = (filename) =>
  request.post(`/admin/backups/${encodeURIComponent(filename)}/restore`, null, {
    timeout: 600000,
  });

export const getDbLastUpdated = () => request.get("/admin/backups/last-updated");

export const deleteBackup = (filename) =>
  request.post(`/admin/backups/${encodeURIComponent(filename)}/delete`);

export const getAssets = (params = {}) => request.get("/assets", { params });
export const createAsset = (payload) => request.post("/assets", payload);
export const updateAsset = (id, payload) => request.put(`/assets/${id}`, payload);
export const deleteAsset = (id) => request.delete(`/assets/${id}`);
export const redirectAsset = (payload) => request.post("/assets/redirect", payload);
export const importFullJson = (payload) => request.post("/import_full_json", payload);
export const exportFullJson = () => request.get("/export_full_json");
export const importAppendJson = (payload) => request.post("/import_append_json", payload);

export const getEpisodes = () => request.get("/episodes");
export const getEpisodeDetail = (id) => request.get(`/episodes/${id}`);
export const createEpisode = (payload) => request.post("/episodes", payload);
export const updateEpisode = (id, payload) =>
  request.put(`/episodes/${id}`, payload);
export const deleteEpisode = (id) => request.delete(`/episodes/${id}`);

export const createPlan = (episodeId, payload) =>
  request.post(`/episodes/${episodeId}/plans`, payload);
export const updatePlan = (id, payload) => request.put(`/plans/${id}`, payload);
export const deletePlan = (id) => request.delete(`/plans/${id}`);
export const getPlanGenMetadata = (planId) =>
  request.get(`/plans/${planId}/gen-metadata`);
/** @param {number} planId @param {boolean|{force?: boolean, prompt?: string, include_prev_video_tail?: boolean, provider?: string}} arg2 兼容旧式 (planId, force) */
export const downloadPlanPackage = (planId, arg2 = false) => {
  let force = false;
  let prompt;
  let includePrevVideoTail;
  let provider;
  if (typeof arg2 === "boolean") {
    force = arg2;
  } else if (arg2 && typeof arg2 === "object") {
    force = !!arg2.force;
    if (arg2.prompt !== undefined) {
      prompt = arg2.prompt;
    }
    if (arg2.include_prev_video_tail !== undefined) {
      includePrevVideoTail = arg2.include_prev_video_tail;
    }
    if (arg2.provider !== undefined) {
      provider = arg2.provider;
    }
  }
  if (prompt !== undefined) {
    const payload = { prompt, force };
    if (includePrevVideoTail !== undefined) {
      payload.include_prev_video_tail = includePrevVideoTail;
    }
    if (provider !== undefined) {
      payload.provider = provider;
    }
    return request.post(`/plans/${planId}/download-package`, payload, {
      timeout: 60000
    });
  }
  const params = { force };
  if (provider !== undefined) {
    params.provider = provider;
  }
  return request.get(`/plans/${planId}/download-package`, {
    params,
    timeout: 60000
  });
};

export const postPlanPackagePreview = (planId, payload) =>
  request.post(`/plans/${planId}/package-preview`, payload, { timeout: 30000 });
export const getPlanAssets = (planId) =>
  request.get(`/plans/${planId}/assets`);

export const uploadImage = (file, onProgress, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/upload/image", formData, {
    timeout: 128000,
    ...config,
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) {
        return;
      }
      onProgress(Math.round((event.loaded * 100) / event.total));
    }
  });
};

export const uploadVideo = (file, onProgress, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/upload/video", formData, {
    timeout: 300000,
    ...config,
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) {
        return;
      }
      onProgress(Math.round((event.loaded * 100) / event.total));
    }
  });
};

export const listImageTasks = (params = {}) => request.get("/image-tasks", { params });
export const getImageTask = (id) => request.get(`/image-tasks/${id}`);
export const createImageTask = (payload) => request.post("/image-tasks", payload);
export const cancelImageTask = (id) => request.post(`/image-tasks/${id}/cancel`);
export const updateImageTaskRemark = (id, remark) =>
  request.post(`/image-tasks/${id}/remark`, { remark });
export const useImageTask = (id) => request.post(`/image-tasks/${id}/use`);

export const uploadTempImage = (file, onProgress, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/upload/temp-image", formData, {
    timeout: 120000,
    ...config,
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) {
        return;
      }
      onProgress(Math.round((event.loaded * 100) / event.total));
    }
  });
};

export const uploadStoryVideo = (file, onProgress, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/upload/story-video", formData, {
    timeout: 600000,
    ...config,
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) {
        return;
      }
      onProgress(Math.round((event.loaded * 100) / event.total));
    }
  });
};

export const joinEpisodeQueue = (id) => request.post(`/episodes/${id}/join-queue`);
export const removeEpisodeQueue = (id) => request.post(`/episodes/${id}/remove-queue`);

// Story Play APIs
export const getStoryPlays = (params = {}) => request.get("/story-plays", { params });
export const checkStoryPlayResources = (id) => request.get(`/story-plays/${id}/check-resources`);
export const createStoryPlay = (payload) => request.post("/story-plays", payload);
export const getStoryPlay = (id) => request.get(`/story-plays/${id}`);
export const updateStoryPlay = (id, payload) => request.put(`/story-plays/${id}`, payload);
export const deleteStoryPlay = (id) => request.delete(`/story-plays/${id}`);

export const getStoryScenes = (playId) => request.get(`/story-plays/${playId}/scenes`);
export const createStoryScene = (playId, payload) => request.post(`/story-plays/${playId}/scenes`, payload);
export const updateStoryScene = (sceneId, payload) => request.put(`/story-scenes/${sceneId}`, payload);
export const deleteStoryScene = (sceneId) => request.delete(`/story-scenes/${sceneId}`);
export const reorderStoryScenes = (playId, payload) => request.post(`/story-plays/${playId}/reorder`, payload);

export const getStoryPlayData = (id) => request.get(`/story-plays/${id}/play`);
/** 导出剧情数据为 SQLite 数据库 ZIP（data.bytes，不含媒体资源文件），返回下载 URL */
export const exportStoryPlay = (id) => request.post(`/story-plays/${id}/export`);
/** 完整 ZIP 包（含 data.db + 媒体文件，见服务端 bundle-download） */
export const prepareStoryPlayBundleDownload = (id) =>
  request.post(`/story-plays/${id}/bundle-download`, {}, { timeout: 600000 });
export const importStoryPlay = (payload) => request.post("/story-plays/import", payload);
// 打包并下载场景匹配的资产
export const downloadSceneAssets = (sceneId, payload) => request.post(`/story-scenes/${sceneId}/download-assets`, payload);

// System Settings APIs
export const listSystemSettings = () => request.get("/system/settings");
export const getSystemSetting = (key) => request.get(`/system/settings/${key}`);
export const updateSystemSetting = (key, payload) => request.put(`/system/settings/${key}`, payload);
export const createSystemSetting = (payload) => request.post("/system/settings", payload);
export const deleteSystemSetting = (key) => request.delete(`/system/settings/${key}`);
export const getResourceCleanupStatus = () => request.get("/system/resources/cleanup-status");
export const startResourceCleanup = () => request.post("/system/resources/cleanup");
export const getResourceCompressStatus = () => request.get("/system/resources/compress-status");
export const startResourceCompress = () => request.post("/system/resources/compress");

export const triggerUpdate = () => request.post("/system/trigger-update");

export const uploadStoryImage = (file, onProgress, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/upload/story-image", formData, {
    timeout: 128000,
    ...config,
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      onProgress(Math.round((event.loaded * 100) / event.total));
    }
  });
};

// Mini Game APIs
export const getMiniGames = () => request.get("/mini-games");
export const createMiniGame = (payload) => request.post("/mini-games", payload);
export const getMiniGame = (id) => request.get(`/mini-games/${id}`);
export const updateMiniGame = (id, payload) => request.put(`/mini-games/${id}`, payload);
export const deleteMiniGame = (id) => request.delete(`/mini-games/${id}`);

export const getMiniGameLevels = (gameId) => request.get(`/mini-games/${gameId}/levels`);
export const createMiniGameLevel = (gameId, payload) => request.post(`/mini-games/${gameId}/levels`, payload);
export const getMiniGameLevel = (levelId) => request.get(`/mini-game-levels/${levelId}`);
export const updateMiniGameLevel = (levelId, payload) => request.put(`/mini-game-levels/${levelId}`, payload);
export const deleteMiniGameLevel = (levelId) => request.delete(`/mini-game-levels/${levelId}`);
export const reorderMiniGameLevels = (gameId, payload) => request.post(`/mini-games/${gameId}/reorder-levels`, payload);

export const getMiniGameResources = () => request.get("/mini-game-resources");
export const createMiniGameResource = (payload) => request.post("/mini-game-resources", payload);
export const getMiniGameResource = (id) => request.get(`/mini-game-resources/${id}`);
export const updateMiniGameResource = (id, payload) => request.put(`/mini-game-resources/${id}`, payload);
export const deleteMiniGameResource = (id) => request.delete(`/mini-game-resources/${id}`);

// Third Party Game APIs
export const getThirdPartyGames = () => request.get("/third-party-games");
export const createThirdPartyGame = (payload) => request.post("/third-party-games", payload);
export const updateThirdPartyGame = (id, payload) => request.put(`/third-party-games/${id}`, payload);
export const deleteThirdPartyGame = (id) => request.delete(`/third-party-games/${id}`);

export const uploadMiniGameMap = (file, onProgress, config = {}) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/upload/mini-game-map", formData, {
    timeout: 300000,
    ...config,
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      onProgress(Math.round((event.loaded * 100) / event.total));
    }
  });
};

export const uploadMiniGameConfig = (config) => request.post("/upload/mini-game-config", { config });
export const uploadMiniGameAudio = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/upload/mini-game-audio", formData);
};
export const downloadAllMiniGamesAndResources = () => request.post("/mini-games/download-all", {}, { timeout: 600000 });
export const getTTSSpeakers = () => request.get("/tts/speakers");
export const getTTSSpeakerAudition = (speakerId) => request.get(`/tts/audition/${speakerId}`);
export const synthesizeTTS = (payload) => request.post("/tts/synthesize", payload);
export const createTTSSpeaker = (payload) => request.post("/tts/speakers", payload);
export const deleteTTSSpeaker = (speakerId) => request.delete(`/tts/speakers/${speakerId}`);

// Levels APIs
export const getLevels = () => request.get("/levels");
export const createLevel = (payload) => request.post("/levels", payload);
export const updateLevel = (id, payload) => request.put(`/levels/${id}`, payload);
export const deleteLevel = (id) => request.delete(`/levels/${id}`);
export const reorderLevels = (payload) => request.post("/levels/reorder", payload);
export const exportLevels = () => request.post("/levels/export", {}, { timeout: 60000 });

